import { render, staticRenderFns } from "./RecordingSearchFilter.vue?vue&type=template&id=b6bea0c8&"
import script from "./RecordingSearchFilter.vue?vue&type=script&lang=js&"
export * from "./RecordingSearchFilter.vue?vue&type=script&lang=js&"
import style0 from "./RecordingSearchFilter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports